import useToastStore from '@/stores/toast/toastStore';
import { Transition, TransitionChild } from '@headlessui/react';
import clsx from 'clsx';
import { useEffect, useState, useRef } from 'react';
import CloseIcon from '../Global/Icons/CloseIcon';
import DButtonIcon from '../Global/DButtonIcon';

const DToastContainer = ({ hideInMobile = false, showFixed = false }) => {
  const { toasts, removeToast } = useToastStore();
  const [countdown, setCountdown] = useState(10);
  const timerRef = useRef(null);
  const currentToastId = useRef(null);

  useEffect(() => {
    if (toasts.length > 0) {
      // Clear any existing timer
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
      
      // Save current toast ID for removal
      currentToastId.current = toasts[0].id;
      setCountdown(10);
      
      timerRef.current = setInterval(() => {
        setCountdown((prev) => {
          // When countdown reaches zero or goes below, remove the toast
          if (prev <= 0.1) {
            clearInterval(timerRef.current);
            // Use a small timeout to ensure the UI shows 0% before removal
            setTimeout(() => {
              if (currentToastId.current) {
                removeToast(currentToastId.current);
              }
            }, 100);
            return 0;
          }
          return prev - 0.1;
        });
      }, 100);

      return () => {
        if (timerRef.current) {
          clearInterval(timerRef.current);
        }
      };
    }
  }, [toasts.length, removeToast]);

  // Handle manual toast removal
  const handleRemoveToast = (id) => {
    clearInterval(timerRef.current);
    currentToastId.current = null;
    removeToast(id);
  };

  return (
    <Transition show={toasts.length > 0}>
      <div
        className={clsx(
          'fixed z-[9999]',
          'left-1/2 -translate-x-1/2 top-[18px]', 
          hideInMobile ? 'hidden sm:block' : 'block',
          'w-full max-w-md px-4'
        )}
      >
        {toasts.slice(0, 1).map((t) => (
          <TransitionChild key={t.id}>
            <div className="relative transition-all duration-150 data-[enter]:delay-100 data-[leave]:delay-0 data-[closed]:opacity-0 data-[closed]:-translate-y-1 bg-white rounded-lg shadow-lg overflow-hidden">
              {/* Toast content */}
              <div className="p-5 py-4 font-medium text-gray-800 flex justify-between items-center">
                <div dangerouslySetInnerHTML={{ __html: t.message }} />
                <DButtonIcon
                  size="sm"
                  onClick={() => handleRemoveToast(t.id)}
                >
                  <CloseIcon className="text-grey-50" />
                </DButtonIcon>
              </div>
              {/* Purple countdown bar */}
              <div className="h-1 bg-gray-100 overflow-hidden">
                <div 
                  className="h-full bg-purple-600 transition-all duration-100" 
                  style={{ width: `${Math.max((countdown / 10) * 100, 0)}%` }}
                />
              </div>
            </div>
          </TransitionChild>
        ))}
      </div>
    </Transition>
  );
};

export default DToastContainer;
